<!-- @format -->

<template>
	<svg
		t="1714358302613"
		class="icon"
		viewBox="0 0 1024 1024"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		p-id="4322"
		width="200"
		height="200"
	>
		<path d="M362.666667 192m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#666666" p-id="4323"></path>
		<path d="M661.333333 192m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#666666" p-id="4324"></path>
		<path d="M362.666667 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#666666" p-id="4325"></path>
		<path d="M661.333333 512m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#666666" p-id="4326"></path>
		<path d="M362.666667 832m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#666666" p-id="4327"></path>
		<path d="M661.333333 832m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#666666" p-id="4328"></path>
	</svg>
</template>
<script lang="ts">
	import type { DefineComponent } from 'vue';
	export default {
		name: 'drag',
	} as DefineComponent;
</script>
